














import { Component, Vue, Provide, Prop, Watch } from "vue-property-decorator";
import Square from "./Square.vue";
import { STATE, PLAYER_O } from "@/constants";
import { Direction } from "@/types";

@Component({
  components: {
    Square
  }
})
export default class Board extends Vue {
  @Provide()
  gameState = STATE.ONGOING;

  @Provide()
  which: number[] = [];

  @Provide()
  direction?: Direction;

  @Prop()
  board: string[];

  @Prop()
  histories: string[][];

  @Prop()
  nextPlayer: string;

  @Prop()
  endGame: boolean;

  @Prop({ default: "player" })
  opponent: string;

  get boardAndEndGame() {
    return {
      endGame: this.endGame,
      board: this.board
    };
  }

  @Watch("endGame", { immediate: true })
  endGameUpdated() {
    if (!this.endGame) {
      this.gameState = STATE.ONGOING;
      this.which = [];
      this.direction = undefined;
    }
  }

  @Watch("boardAndEndGame", { immediate: true, deep: true })
  boardUpdated(val: { endGame: boolean; board: string[] }) {
    const { endGame, board } = val;
    const numOccupiedCells = board.filter(b => b !== "").length;
    const aiMadeMove = numOccupiedCells > 0 && numOccupiedCells % 2 === 0;
    if (!endGame && this.opponent !== "player" && aiMadeMove) {
      const { state, which = [], direction = undefined } =
        this.checkWinner(board) || {};
      this.gameState = state;
      this.which = which;
      this.direction = direction;
      if (this.gameState === STATE.ONGOING) {
        this.$emit("changePlayer");
      } else {
        this.$emit("announcementWinner", this.gameState);
      }
    }
  }

  winningClass(i: number) {
    if (this.which.indexOf(i) >= 0) {
      return `winning-${this.direction}`;
    }
    return "";
  }

  update(index: number) {
    if (this.endGame || this.gameState !== STATE.ONGOING) {
      return;
    }

    if (this.opponent !== "player" && this.nextPlayer === PLAYER_O) {
      return;
    }

    const newBoard = this.board.reduce(
      (acc, v, i) =>
        i === index ? acc.concat(this.nextPlayer) : acc.concat(v),
      [] as string[]
    );

    const { state, which = [], direction = undefined } =
      this.checkWinner(newBoard) || {};
    this.gameState = state;
    this.which = which;
    this.direction = direction;
    if (this.gameState === STATE.ONGOING) {
      this.$emit("changePlayer");
      this.$emit("allMoves", [...this.histories, newBoard]);
    } else {
      this.$emit("allMoves", [...this.histories, newBoard]);
      this.$emit("announcementWinner", this.gameState);
    }
  }

  checkWinner(newBoard: string[]) {
    const winningMoves = [
      [0, 1, 2],
      [3, 4, 5],
      [6, 7, 8],
      [0, 3, 6],
      [1, 4, 7],
      [2, 5, 8],
      [0, 4, 8],
      [2, 4, 6]
    ];
    const directions = [
      Direction.HORT,
      Direction.HORT,
      Direction.HORT,
      Direction.VERTICAL,
      Direction.VERTICAL,
      Direction.VERTICAL,
      Direction.LEFT_DIAG,
      Direction.RIGHT_DIAG
    ];

    // let hasWinner = true;
    for (let i = 0; i < winningMoves.length; i++) {
      const hasWinner =
        winningMoves[i].filter(m => newBoard[m] !== this.nextPlayer).length ===
        0;
      if (hasWinner) {
        return {
          state: STATE.WINNER,
          which: winningMoves[i],
          direction: directions[i]
        };
      }
    }
    if (newBoard.filter(v => v !== "").length === 9) {
      return { state: STATE.TIED };
    }
    return { state: STATE.ONGOING };
  }
}
